<script>
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import CatalogButton from "@js/components/Buttons/CatalogButton.vue";
import FeedbackTopCommentItem
    from "@js/components/Sections/TopComponents/Components/Feedback/FeedbackTopCommentItem.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import IconLike from "@js/components/Icons/IconLike.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

export default {
    name: "FeedbacksTopComponent",
    components: {
        Breadcrumbs,
        IconLike,
        OnlyDesktop,
        FeedbackTopCommentItem,
        CatalogButton,
        CallbackButton
    },
    data() {
        return {
            top_comments: [
                {
                    text: 'Нужно было срочно заказать дорожные плиты для стройки. Позвонил, уточнил наличие – в тот же день оформили заказ. Доставку организовали уже на следующий день! Водитель приехал вовремя, разгрузка прошла четко, без проблем. Плиты ровные, без брака, прочные.',
                    name: 'Василий',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=kcejafk970v4wt8qxqqmt2bn8r&utm_source=review',
                },
                {
                    text: 'Дмитрий — отличный специалист. Подробно объяснил разницу между разными видами плит, предложил несколько вариантов на выбор. Мы остановились на более прочных моделях, чтобы выдерживали вес грузового транспорта. Рекомендую!',
                    name: 'Артур Гулян',
                    link: 'https://yandex.com/maps/org/159145062474/reviews?reviews%5BpublicId%5D=jgyn2uqt41qb7agq7hudtvdq8r&utm_source=review',
                }
            ]
        }
    }
}
</script>

<template>
    <div
        class="relative ling-bg flex justify-center md:items-center items-start text-center  bg-[url('@img/backgrounds/feedbacks/sm.svg')] lg:bg-[url('@img/backgrounds/feedbacks/lg.svg')] bg-no-repeat bg-cover bg-bottom md:bg-right-bottom bg-img pt-10 pb-10 md:pt-20 md:pb-20">
        <div class="container grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-20">
            <div class="text-left mb-10 mb:mb-0">
                <Breadcrumbs class="mb-2"/>
                <h1 class="text-2xl md:text-4xl font-bold text-black">
                    Отзывы наших клиентов
                </h1>
                <ul class="max-w-xl space-y-5 list-disc list-inside text-black text-sm md:text-base mt-8 font-medium">
                    <li class="flex items-center justify-start">
                        <div>
                            <IconLike class="w-6 h-6 me-5 text-[#16A34A]"/>
                        </div>
                        95% клиентов довольны нашим сервисом – мы ценим ваше доверие и стремимся поддерживать высокий уровень обслуживания.
                    </li>
                    <li class="flex items-center justify-start">
                        <div>
                            <IconLike class="w-6 h-6 me-5 text-[#16A34A]"/>
                        </div>
                        Работаем на результат – каждый день мы улучшаем наши процессы, чтобы превзойти ожидания клиентов.
                    </li>
                    <li class="flex items-center justify-start">
                        <div>
                            <IconLike class="w-6 h-6 me-5 text-[#16A34A]"/>
                        </div>
                        Качество без компромиссов – используем только проверенные материалы и соблюдаем все строительные нормы.
                    </li>
                    <li class="flex items-center justify-start">
                        <div>
                            <IconLike class="w-6 h-6 me-5 text-[#16A34A]"/>
                        </div>
                        Быстрая доставка и индивидуальный подход – учитываем потребности каждого клиента, предлагая гибкие условия сотрудничества
                    </li>
                </ul>
                <OnlyDesktop>
                    <div class="block md:inline-flex items-center gap-5 mt-10">
                        <CallbackButton class="w-full md:w-auto"/>
                        <CatalogButton class="mt-5 md:mt-0 w-full md:w-auto"
                                       :isBlurry="true"
                                       :dark="true"/>
                    </div>
                </OnlyDesktop>
            </div>
            <div>
                <div class="flex justify-start md:justify-center lg:justify-end mb-10">
                    <FeedbackTopCommentItem :text="top_comments[0].text"
                                            :name="top_comments[0].name"
                                            :link="top_comments[0].link"/>
                </div>
                <div class="hidden md:flex justify-start md:justify-center lg:justify-start">
                    <FeedbackTopCommentItem :text="top_comments[1].text"
                                            :name="top_comments[1].name"
                                            :link="top_comments[1].link"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.ling-bg::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 90%;
    background-image: url("@img/backgrounds/feedbacks/line.svg");
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: contain;
    z-index: -1;
}
</style>
